angular.module('impactx.item').controller('ItemDataTableCtrl', [
    'TranslationService',
    ItemDataTableCtrl]);

function ItemDataTableCtrl( TranslationService) {
    var self = this;
    self.trns = {
        content: TranslationService.get('content')
    }
}